import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Image from 'common/image'

const BoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 1164px;
    padding: 48px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`

const TitleUnderLine = styled.div`
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const ContentText = styled.div`
    margin-top: 16px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const LowerPartSection = styled.div`
    margin-top: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const LeftSection = styled.div`
    width: 520px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`

const FirstLineRow = styled.div`
    display: flex;
    flex-direction: row;
`

const FirstLineText = styled.div`
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 35px; /* 175% */
`

const SecondLineText = styled.div`
    padding-top: 24px;
    color: #4e3821;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const RightSection = styled.div``

export default function AboutProgramme() {
    const { t } = useTranslation('', {
        keyPrefix: 'priorityprogramme.aboutprogrammewidget',
    })

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t(`title`)}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <ContentText>{t(`content1`)}</ContentText>
            <ContentText>{t(`content2`)}</ContentText>
            <ContentText>{t(`content3`)}</ContentText>
            <LowerPartSection>
                <LeftSection>
                    <FirstLineRow>
                        <FirstLineText>{t(`subtitle`)}</FirstLineText>
                    </FirstLineRow>
                    <SecondLineText>{t(`subcontent1`)}</SecondLineText>
                    <SecondLineText>{t(`subcontent2`)}</SecondLineText>
                </LeftSection>
                <RightSection>
                    <Image
                        src={t(`image`)}
                        width={500}
                        height={333}
                        style={{ borderRadius: '25px' }}
                        alt="About priority programme banner"
                    />
                </RightSection>
            </LowerPartSection>
        </BoxContainer>
    )
}
